import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faFacebook, faSpotify, faInstagram } from "@fortawesome/free-brands-svg-icons";
import Navbar from "./components/Navbar/Navbar";
import Inicio from "./inicio/inicio";
import Music from "./music/music";
import Culture from "./culture/culture";
import History from "./history/history";
import Territory from "./territory/territory";
import Hiring from "./hiring/hiring";
import Gallery from "./galery/galery";
import EPK from "./epk/epk";
import Baltiptsy from "./music/baltiptsy/baltiptsy";
import KujipySchema from "./schema_markup/KujipySchema";
import SeoManager from "./components/SeoManager/SeoManager";
import GoogleAnalytics from "./components/GoogleAnalytics/GoogleAnalytics";
import Privacy from "./privacy/privacy";
import { useTranslation } from "react-i18next";
import "./i18n";
import "./App.css";

const socials = [
  ["YouTube", "https://www.youtube.com/@kujipyoficial8421", faYoutube],
  ["Facebook", "https://www.facebook.com/kujipy", faFacebook],
  ["Spotify", "https://open.spotify.com/artist/3tDuuuTkPprgYHtL7QsvXs", faSpotify],
  ["Instagram", "https://www.instagram.com/kujipy", faInstagram]
] as const;

const NoMatch = () => { const { t } = useTranslation(); return <main className="not-found"><p className="eyebrow">Error 404</p><h1>{t("notFound.title")}</h1><p>{t("notFound.text")}</p><Link className="button button--primary" to="/">{t("notFound.back")}</Link></main>; };

const App = () => { const { t } = useTranslation(); return <BrowserRouter>
  <KujipySchema />
  <SeoManager />
  <GoogleAnalytics />
  <div className="App">
    <Navbar />
    <div className="HeaderStaticBar" aria-hidden="true">
      <div className="ImageStaticBar">
        <div className="ImageBackground" />
      </div>
    </div>
    <div className="app-content"><Routes>
      <Route path="/" element={<Inicio />} /><Route path="/music" element={<Music />} />
      <Route path="/culture" element={<Culture />} /><Route path="/history" element={<History />} />
      <Route path="/gallery" element={<Gallery />} /><Route path="/galery" element={<Navigate to="/gallery" replace />} /><Route path="/hiring" element={<Hiring />} />
      <Route path="/tlahuitoltepec" element={<Territory />} /><Route path="/epk" element={<EPK />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/music/baltiptsy" element={<Baltiptsy />} /><Route path="*" element={<NoMatch />} />
    </Routes></div>
    <footer className="FootPage"><div className="FootPageText"><div className="social-media-container-footer">{socials.map(([name, href, icon]) => <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={name}><FontAwesomeIcon icon={icon} /></a>)}</div><div className="derechos"><strong>© Kujipy {new Date().getFullYear()}</strong><br />{t("footer.rights")} · <Link to="/privacy">{t("privacy.link")}</Link></div></div></footer>
  </div>
</BrowserRouter>; };

export default App;
